<div
  *ngIf="[FormState.confirm, FormState.submitting].includes(formState$ | async)"
  class="modal-header"
>
  <h2>Please confirm again</h2>
</div>
<div *ngIf="FormState.success === (formState$ | async)" class="modal-header">
  <h2>Action Success!</h2>
</div>
<div *ngIf="FormState.failure === (formState$ | async)" class="modal-header">
  <h2>Action Failed!</h2>
</div>
<div>
  <div class="modal-body">
    <h5 *ngIf="FormState.confirm === (formState$ | async)">
      Remove permissons from the following
      {{ selectedUsersCount$ | async }} account-users:
    </h5>
    <h5 *ngIf="FormState.submitting === (formState$ | async)">
      Removing permissons from the following
      {{ selectedUsersCount$ | async }} account-users:
    </h5>
    <h5 *ngIf="FormState.success === (formState$ | async)">
      Removed permissons from the following
      {{ selectedUsersCount$ | async }} account-users:
    </h5>
    <h5 *ngIf="FormState.failure === (formState$ | async)">
      Could not remove permissons from the following
      {{ selectedUsersCount$ | async }} account-users:
    </h5>

    <app-table-headers>
      <app-table-header class="flex">email</app-table-header>
      <app-table-header class="flex">Account (id)</app-table-header>
      <app-table-header class="flex-half">License</app-table-header>
      <app-table-header class="flex-half">Permission</app-table-header>
      <app-table-header class="icon-cell"></app-table-header>
    </app-table-headers>

    <app-table-content>
      <app-table-row *ngFor="let user of bulkEditUsers$ | async">
        <app-table-cell class="flex">
          {{ user.email }}
        </app-table-cell>
        <app-table-cell class="flex">
          {{ user.accountId }}
        </app-table-cell>
        <app-table-cell class="flex-half tool">
          {{ user.licenseCode }}
          <span class="tooltiptext">{{ user.licenseCode }}</span>
        </app-table-cell>
        <app-table-cell class="flex-half tool">
          {{ user.permissionCode }}
          <span class="tooltiptext">{{ user.permissionCode }}</span>
        </app-table-cell>
        <app-table-cell class="icon-cell">
          <app-loading-spinner
            *ngIf="(formState$ | async) === FormState.submitting"
            size="md"
          ></app-loading-spinner>
          <ng-container
            *ngIf="
              [FormState.success, FormState.failure].includes(
                formState$ | async
              )
            "
          >
            <i
              *ngIf="user | bulkUserPipe: (bulkEditSuccess$ | async)"
              class="fas fa-check-circle"
            ></i>
            <i
              *ngIf="
                !(user | bulkUserPipe: (bulkEditSuccess$ | async)) ||
                (formState$ | async) === FormState.failure
              "
              class="fas fa-times-circle"
            ></i>
          </ng-container>
        </app-table-cell>
      </app-table-row>
    </app-table-content>
  </div>

  <div class="modal-footer">
    <button
      *ngIf="FormState.success !== (formState$ | async)"
      type="button"
      class="btn btn-primary"
      (click)="confirm()"
      [disabled]="FormState.confirm !== (formState$ | async)"
    >
      Confirm
    </button>
    <button
      *ngIf="FormState.success === (formState$ | async)"
      type="button"
      class="btn btn-outline-dark"
      (click)="export()"
    >
      Export action log
    </button>
    <button
      type="button"
      [ngClass]="
        FormState.success === (formState$ | async)
          ? 'btn btn-primary'
          : 'btn btn-outline-dark'
      "
      (click)="activeModal.close()"
      [disabled]="
        ![FormState.success, FormState.confirm, FormState.failure].includes(
          formState$ | async
        )
      "
    >
      close
    </button>
  </div>
</div>
